import Routers from "./router";
import clientStore from './store'
export default {
    install(vue, {router,store}){
        router.addRoute(Routers)
        store.registerModule('clientModule', clientStore)
    }
}